export default {
    'pages.branch.Add Branch': 'Add Branch',
    'pages.branch.Branch Card': 'Branch Card',
    'pages.branch.Branch': 'Branch',
    'pages.branch.Re-assign Branch': 'Re-assign Branch',
    'pages.branch.Transfer Sales': 'Transfer Sales',
    'pages.branch.Policies': 'Policies',
    'pages.branch.Branch Policies': 'Branch Policies',
    'pages.branch.Agencies': 'Agencies',

    'pages.agencies.Agency Card': 'Agency Card',
    'pages.agencies.General': 'General',
    'pages.agencies.Agency': 'Agency',
    'pages.agencies.Agents': 'Agents',
    'pages.agencies.Policies': 'Policies',
    'pages.agencies.Agency Policies': 'Agency Policies',
    'pages.agencies.Documents': 'Documents',
    'pages.agencies.Add Agency': 'Add Agency',
    'pages.agencies.Other': 'Other',

    'pages.customers.Add Customer': 'Add Customer',
    'pages.customers.Customer': 'Customer',
    'pages.customers.Info': 'Info',
    'pages.customers.Policies': 'Policies',
    'pages.customers.Customer Policies': 'Customer Policies',

    'pages.hospitals.Add Hospital': 'Add Hospital',
    'pages.hospitals.Hospital': 'Hospital',

    'pages.insurers.Add Insurer': 'Add Insurer',
    'pages.insurers.Insurer': 'Insurer',

    'pages.intermediaries.Add Intermediary': 'Add Intermediary',
    'pages.intermediaries.Intermediary': 'Intermediary',

    'pages.underwriters.Add Underwriter': 'Add Underwriter',
    'pages.underwriters.Underwriter': 'Underwriter',

    'pages.finance.TableOfEntries': 'Table of Entries',
    'pages.finance.delete Entries': 'Delete Entries',
    'page.finance.total amount': 'Total amount',
    'page.finance.selectedInvoices': 'Selected Invoices:',

    'page.finance.searchAgency': 'Search agency',
};
